    import { Outlet } from "react-router-dom";
    import MusicPlayer from "../components/MusicPlayer";

    export default function KaipediaLayout() {
    return (
        <>
        <MusicPlayer />
        <Outlet />
        </>
    );
    }